import productsSlice from './productsSlice';

export * from './thunks';

export default productsSlice;
